import { Injectable, Type } from '@angular/core';
import { BaseChartComponent } from '../components/organisms/base-chart/base-chart.component';
import { MapComponent } from '../components/organisms/grid/widgets/map/map.component';
import { TextComponent } from '../components/organisms/grid/widgets/text/text.component';
import { InfoComponent } from '../components/organisms/grid/widgets/info/info.component';
import { TableComponent } from '../components/organisms/grid/widgets/table/table.component';
import { TeaserComponent } from '../components/organisms/grid/widgets/teaser/teaser.component';

@Injectable({
  providedIn: 'root',
})
export class DynamicComponentLoaderService {
  // Map of component types based on customConfig types
  private componentMap: { [key: string]: Type<any> } = {
    bar: BaseChartComponent,
    pie: BaseChartComponent,
    doughnut: BaseChartComponent,
    map: MapComponent,
    scatter: BaseChartComponent,
    bubble: BaseChartComponent,
    line: BaseChartComponent,
    info: InfoComponent,
    teaser: TeaserComponent,
    table: TableComponent,
    text: TextComponent,
    polarArea: BaseChartComponent,
    radar: BaseChartComponent,
  };

  // Dynamically load the correct component based on the type
  getWidgetConfig(type: string, input: any = {}) {
    const component = this.componentMap[type];
    //const component = BaseChartComponent;

    if (!component) {
      throw new Error(`Component type ${type} not found!`);
    }
    return {
      component,
      inputs: input,
    };
  }
}
